/** @jsxImportSource @emotion/react */
// Mismos estilos y en el mismo orden que el admin: el orden cambia qué regla
// gana entre themeCustomization.css y el tema de PrimeReact
import "./shared/styles/App.css";
import "./shared/styles/themeCustomization.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
// PRUEBA: import de portal.css desactivado para ver el Titulo sin él
// import "./estilos/portal.css";
import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Router from "./Router";
import { accessAPI, Estetica, FooterMorfeo, Header, readFromLS } from "./shared";
import { PrimeReactProvider } from "primereact/api";
import EulaGate from "./elementos/EulaGate";

// Misma estructura que el admin: Header compartido, el Router (que arma el
// contenedor de cada sección) y el footer. La marca (colores, logos, favicon,
// título) la aplica Estetica con la configuración del organismo.
export default function App() {
  return (
    <PrimeReactProvider>
      <Estetica app="CLIENTE">
        <BrowserRouter>
          <div
            // Columna del alto de la ventana: como el footer tiene margin-top
            // auto, queda abajo de todo aunque el contenido no llene la pantalla.
            css={{
              display: "flex",
              flexDirection: "column",
              minHeight: "100vh"
            }}
          >
            <div
              // El contenido va en su propio div y no suelto en la columna
              // flex: App.css le da `margin: auto` horizontal a <main>, y en un
              // flex container los márgenes auto anulan el stretch y lo
              // encogerían al ancho del texto.
              css={{ flex: "1 0 auto" }}
            >
              <HeaderCliente />
              <EulaGate />
              <Router />
            </div>
            <FooterMorfeo />
          </div>
        </BrowserRouter>
      </Estetica>
    </PrimeReactProvider>
  );
}

// Header con la navegación del portal. Propuestas, Hallazgos y Facturación
// muestran en un badge cuántos pendientes tienen (los mismos de "Requiere tu
// atención"); se vuelven a pedir al cambiar de pantalla, para que bajen
// después de responder, aceptar o pagar.
function HeaderCliente() {
  const { pathname } = useLocation();
  const [pendientes, setPendientes] = useState(null);
  useEffect(() => {
    // Sin sesión (login, archivo público) no hay pendientes que pedir
    if (!readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN)) return;
    accessAPI(
      "GET",
      "cliente/destacados",
      null,
      (r) =>
        setPendientes({
          propuestas: (r.propuestas?.length || 0) + (r.sabanas?.length || 0),
          hallazgos: r.hallazgos?.length || 0,
          facturas: r.facturas?.length || 0
        }),
      () => setPendientes(null)
    );
  }, [pathname]);

  return (
    <Header
      menuUsuarioProps={{
        opcionesRol: ["administrador", "auditor"],
        permitirCambioEmpresa: true
      }}
      botonesMenuUsuario={[{ etiqueta: "Mi cuenta", uri: "/cuenta", icono: "pi pi-user" }]}
      botonera={[
        { etiqueta: "Inicio", url: "/" },
        { etiqueta: "Certificados", url: "/certificados" },
        { etiqueta: "Actividades", url: "/procesos" },
        { etiqueta: "Propuestas", url: "/propuestas", badge: pendientes?.propuestas },
        { etiqueta: "Hallazgos", url: "/hallazgos", badge: pendientes?.hallazgos },
        { etiqueta: "Facturación", url: "/facturacion", badge: pendientes?.facturas }
      ]}
    />
  );
}
